import AnexosAprovacaoListaPage from '@/views/docs/operacional/AnexosAprovacaoListaPage.vue';
import AnexosSupervisorListaPage from '@/views/listas/AnexosSupervisorListaPage.vue';
import AssinaturasPendentesTabPage from '@/views/operacional/tabelas/AssinaturasPendentesTabPage.vue';
import AtividadesTabPage from '@/views/cadastros/tabelas/AtividadesTabPage.vue';
import CapacidadeProducaoReportPage from '@/views/reports/CapacidadeProducaoReportPage.vue';
import ColetaCintaReportPage from '@/views/reports/ColetaCintaReportPage.vue';
import ColetaNCAnaliticoReportPage from '@/components/reports/ColetaNCAnaliticoReportPage.vue';
import ContasEmailTabPage from '@/views/cadastros/tabelas/ContasEmailTabPage.vue';
import DocAnulacaoEstabelecimentosTabPage from '@/views/docs/tabelas/DocAnulacaoEstabelecimentosTabPage.vue';
import DocHistoricoPage from '@/views/docs/tabelas/DocHistoricoPage.vue';
import DocTabPage from '@/views/docs/tabelas/DocTabPage.vue';
import DocumentosEstabelecimentoPastaPage from '@/views/docs/visualizacoes/DocumentosEstabelecimentoPastaPage.vue';
import DocumentosGestaoPage from '@/components/operacoes/DocumentosGestaoPage.vue';
import DriveGrupoTabPage from '@/views/utils/drive/DriveGrupoTabPage.vue';
import DriveInternoListaPage from '@/views/utils/drive/DriveInternoListaPage.vue';
import DrivePastaTabPage from '@/views/utils/drive/DrivePastaTabPage.vue';
import DrivePastaPublicaTabPage from '@/views/utils/drive/DrivePastaPublicaTabPage.vue';
import EpAiHybridPage from '@/views/cadastros/hybrid/EpAiHybridPage.vue';
import EpDocModeloTabPage from '@/views/cadastros/tabelas/EpDocModeloTabPage.vue';
import EpEditPage from '@/views/cadastros/formularios/EpEditPage.vue';
import EpMenuDocHybridPage from '@/views/cadastros/hybrid/EpMenuDocHybridPage.vue';
import EpMenuProcHybridPage from '@/views/cadastros/hybrid/EpMenuProcHybridPage.vue';
import EpRdTabPage from '@/views/cadastros/tabelas/EpRdTabPage.vue';
import EstabelecimentoDashPage from '@/components/dashboards/EstabelecimentoDashPage.vue';
import EstabelecimentoProdutoMapaConfigPage from '@/views/cadastros/tabelas/EstabelecimentoProdutoMapaConfigPage.vue';
import EstabelecimentosCliTabPage from '@/views/cadastros/tabelas/EstabelecimentosCliTabPage.vue';
import EstabelecimentosCpProducaoPage from '@/views/cadastros/tabelas/EstabelecimentosCpProducaoPage.vue';
import EstabelecimentosForTabPage from '@/views/cadastros/tabelas/EstabelecimentosForTabPage.vue';
import EstabelecimentosInspetorTabPage from '@/views/cadastros/tabelas/EstabelecimentosInspetorTabPage.vue';
import EstabelecimentosReportPage from '@/views/reports/EstabelecimentosReportPage.vue';
import EstabelecimentosRtTabPage from '@/views/cadastros/tabelas/EstabelecimentosRtTabPage.vue';
import EstebelecimentosParecerReportPage from '@/components/reports/EstebelecimentosParecerReportPage.vue';
import FaqsPage from '@/views/utils/help/FaqsPage.vue';
import FeriadosTabPage from '@/views/cadastros/tabelas/FeriadosTabPage.vue';
import ListaAtividadesPage from '@/views/planilhas/tabelas/ListaAtividadesPage.vue';
import MapaEnderecosPage from '@/views/dashboard/MapaEnderecosPage.vue';
import MapaEstatisticoReportPage from '@/components/reports/MapaEstatisticoReportPage.vue';
import MunicipiosTabPage from '@/views/cadastros/tabelas/MunicipiosTabPage.vue';
import NCAnaliticoReportPage from '@/components/reports/NCAnaliticoReportPage.vue';
import PacTabPage from '@/views/cadastros/tabelas/PacTabPage.vue';
import Pla01CancelamentoPage from '@/views/planilhas/formularios/Pla01CancelamentoPage.vue';
import Pla01TabPage from '@/views/planilhas/tabelas/Pla01TabPage.vue';
import Pla06TabPage from '@/views/planilhas/tabelas/Pla06TabPage.vue';
import Pla08TabPage from '@/views/planilhas/tabelas/Pla08TabPage.vue';
import Pla08DeferimentoTabPage from '@/views/planilhas/tabelas/Pla08DeferimentoTabPage.vue';
import Pla08PendenteTabPage from '@/views/planilhas/tabelas/Pla08PendenteTabPage.vue';
import PlaExpedicaoTabPage from '@/views/planilhas/tabelas/PlaExpedicaoTabPage.vue';
import PlaLeiteTabPage from '@/views/planilhas/tabelas/PlaLeiteTabPage.vue';
import PlaMelTabPage from '@/views/planilhas/tabelas/PlaMelTabPage.vue';
import PlaMpTabPage from '@/views/planilhas/tabelas/PlaMpTabPage.vue';
import PlaProducaoTabPage from '@/views/planilhas/tabelas/PlaProducaoTabPage.vue';
import ProcCancelamentoPage from '@/views/proc/formularios/ProcCancelamentoPage.vue';
import ProcModeloTabPage from '@/views/cadastros/tabelas/ProcModeloTabPage.vue';
import ProcPendentesTabPage from '@/views/proc/tabelas/ProcPendentesTabPage.vue';
import ProcPesquisaPage from '@/views/proc/tabelas/ProcPesquisaPage.vue';
import ProcTabPage from '@/views/proc/tabelas/ProcTabPage.vue';
import ProdutosMapaTabPage from '@/views/cadastros/tabelas/ProdutosMapaTabPage.vue';
import ProdutosTabPage from '@/views/cadastros/tabelas/ProdutosTabPage.vue';
import RacDeferimentoTabPage from '@/views/operacional/tabelas/RacDeferimentoTabPage.vue';
import RacPendenteTabPage from '@/views/operacional/tabelas/RacPendenteTabPage.vue';
import RacTabPage from '@/views/operacional/tabelas/RacTabPage.vue';
import RastreabilidadeReportPage from '@/views/reports/RastreabilidadeReportPage.vue';
import ResumoGeralPage from '@/components/dashboards/ResumoGeralPage.vue';
import SimInspetorEditPage from '@/views/cadastros/associacoes/SimInspetorEditPage.vue';
import SimsInspetorTabPage from '@/views/cadastros/tabelas/SimsInspetorTabPage.vue';
import SimsSupervisorTabPage from '@/views/cadastros/tabelas/SimsSupervisorTabPage.vue';
import TpDocsTabPage from '@/views/cadastros/tabelas/TpDocsTabPage.vue';
import TpDocsGrupoTabPage from '@/views/cadastros/tabelas/TpDocsGrupoTabPage.vue';
import TpProducaoTabPage from '@/views/cadastros/tabelas/TpProducaoTabPage.vue';
import TutoriaisPage from '@/views/utils/help/TutoriaisPage.vue';
import UsuarioViewPage from '@/views/cadastros/visualizacoes/UsuarioViewPage.vue';
import UsuariosAdminTabPage from '@/views/cadastros/tabelas/UsuariosAdminTabPage.vue';
import UsuariosComPerfilTabPage from '@/views/cadastros/tabelas/UsuariosComPerfilTabPage.vue';
import UsuariosGestoresTabPage from '@/views/cadastros/tabelas/UsuariosGestoresTabPage.vue';
import UsuariosInspetoresTabPage from '@/views/cadastros/tabelas/UsuariosInspetoresTabPage.vue';
import UsuariosPerfilTabPage from '@/views/cadastros/tabelas/UsuariosPerfilTabPage.vue';
import UsuariosRtTabPage from '@/views/cadastros/tabelas/UsuariosRtTabPage.vue';
import UsuariosSupervisoresTabPage from '@/views/cadastros/tabelas/UsuariosSupervisoresTabPage.vue';


import ProcessosAberturaForm_24 from '@/views/poc/cadastros/ProcessosAberturaForm_24.vue';
import ProtocoloAutoInfracao_31 from '@/views/poc/operacional/ProtocoloAutoInfracao_31.vue';


export const componentRegistry = {
    AnexosAprovacaoListaPage,
    AnexosSupervisorListaPage,
    AssinaturasPendentesTabPage,
    AtividadesTabPage,
    CapacidadeProducaoReportPage,
    ColetaCintaReportPage,
    ColetaNCAnaliticoReportPage,
    ContasEmailTabPage,
    DocAnulacaoEstabelecimentosTabPage,
    DocHistoricoPage,
    DocTabPage,
    DocumentosEstabelecimentoPastaPage,
    DocumentosGestaoPage,
    DriveGrupoTabPage,
    DriveInternoListaPage,
    DrivePastaTabPage,
    DrivePastaPublicaTabPage,
    EpAiHybridPage,
    EpDocModeloTabPage,
    EpEditPage,
    EpMenuDocHybridPage,
    EpMenuProcHybridPage,
    EpRdTabPage,
    EstabelecimentoDashPage,
    EstabelecimentoProdutoMapaConfigPage,
    EstabelecimentosCliTabPage,
    EstabelecimentosCpProducaoPage,
    EstabelecimentosForTabPage,
    EstabelecimentosInspetorTabPage,
    EstebelecimentosParecerReportPage,
    EstabelecimentosReportPage,
    EstabelecimentosRtTabPage,
    FaqsPage,
    FeriadosTabPage,
    ListaAtividadesPage,
    MapaEnderecosPage,
    MapaEstatisticoReportPage,
    MunicipiosTabPage,
    NCAnaliticoReportPage,
    PacTabPage,
    Pla01CancelamentoPage,
    Pla01TabPage,
    Pla06TabPage,
    Pla08TabPage,
    Pla08DeferimentoTabPage,
    Pla08PendenteTabPage,
    PlaExpedicaoTabPage,
    PlaLeiteTabPage,
    PlaMelTabPage,
    PlaMpTabPage,
    PlaProducaoTabPage,
    ProcCancelamentoPage,
    ProcModeloTabPage,
    ProcPendentesTabPage,
    ProcPesquisaPage,
    ProcTabPage,
    ProdutosMapaTabPage,
    ProdutosTabPage,
    RacDeferimentoTabPage,
    RacPendenteTabPage,
    RacTabPage,
    RastreabilidadeReportPage,
    ResumoGeralPage,
    SimInspetorEditPage,
    SimsInspetorTabPage,
    SimsSupervisorTabPage,
    TpDocsTabPage,
    TpDocsGrupoTabPage,
    TpProducaoTabPage,
    TutoriaisPage,
    UsuarioViewPage,
    UsuariosAdminTabPage,
    UsuariosComPerfilTabPage,
    UsuariosGestoresTabPage,
    UsuariosInspetoresTabPage,
    UsuariosPerfilTabPage,
    UsuariosRtTabPage,
    UsuariosSupervisoresTabPage,

    ProcessosAberturaForm_24,
    ProtocoloAutoInfracao_31,
};